module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box-body"
  }, [_c('form', {
    staticClass: "form",
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit($event)
      }
    }
  }, [_c('h5', [_vm._v("Bucket name")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      input: true,
        'is-danger': _vm.errors.has('bname'),
    },
    attrs: {
      "data-vv-delay": "200",
      "name": "bname",
      "type": "text",
      "placeholder": "Bucket Name",
      "disabled": _vm.formData.bname == 'default'
    },
    model: {
      value: (_vm.formData.bname),
      callback: function($$v) {
        _vm.$set(_vm.formData, "bname", $$v)
      },
      expression: "formData.bname"
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('bname')),
      expression: "errors.has('bname')"
    }],
    staticClass: "help is-danger"
  }, [_vm._v(_vm._s(_vm.errors.first("bname")))]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select country",
      "multiple": "",
      "filterable": "",
      "disabled": _vm.formData.bname == 'default'
    },
    on: {
      "remove-tag": _vm.deleteCountry,
      "change": _vm.countriesChange
    },
    model: {
      value: (_vm.formData.country),
      callback: function($$v) {
        _vm.$set(_vm.formData, "country", $$v)
      },
      expression: "formData.country"
    }
  }, _vm._l((_vm.countries), function(option) {
    return _c('el-option', {
      key: option.id,
      attrs: {
        "label": option.name,
        "value": option.id,
        "disabled": _vm.formData.bname == 'default' ||
          _vm.displayexistingCountries.indexOf(
            option.id
          ) > -1
      }
    })
  }), 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Associate Products")]), _vm._v(" "), _c('el-select', {
    attrs: {
      "placeholder": "Select products"
    },
    model: {
      value: (_vm.formData.prod),
      callback: function($$v) {
        _vm.$set(_vm.formData, "prod", $$v)
      },
      expression: "formData.prod"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "Select a product",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.products), function(prod) {
    return _c('el-option', {
      key: prod.id,
      attrs: {
        "label": prod.name,
        "value": prod.id
      }
    })
  })], 2), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Bucket features")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.formData.refresh_all_initially
    },
    model: {
      value: (_vm.formData.refresh_all_after_bids),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refresh_all_after_bids", $$v)
      },
      expression: "formData.refresh_all_after_bids"
    }
  }, [_vm._v("Refresh all units after bids")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.formData.refresh_all_after_bids
    },
    model: {
      value: (_vm.formData.refresh_all_initially),
      callback: function($$v) {
        _vm.$set(_vm.formData, "refresh_all_initially", $$v)
      },
      expression: "formData.refresh_all_initially"
    }
  }, [_vm._v("Refresh all units initially")])], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enable Ad Lightning?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('el-switch', {
    model: {
      value: (_vm.formData.ad_lightnings_enable),
      callback: function($$v) {
        _vm.$set(_vm.formData, "ad_lightnings_enable", $$v)
      },
      expression: "formData.ad_lightnings_enable"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Enable Fouanalytics?")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('el-switch', {
    model: {
      value: (_vm.formData.fouanalytics_enable),
      callback: function($$v) {
        _vm.$set(_vm.formData, "fouanalytics_enable", $$v)
      },
      expression: "formData.fouanalytics_enable"
    }
  })], 1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h5', [_vm._v("Devices")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.formData.isMobileEnable
    },
    model: {
      value: (_vm.formData.isMobile),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isMobile", $$v)
      },
      expression: "formData.isMobile"
    }
  }, [_vm._v("Mobile enabled?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.formData.isWebEnable
    },
    model: {
      value: (_vm.formData.isWeb),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isWeb", $$v)
      },
      expression: "formData.isWeb"
    }
  }, [_vm._v("Web enabled?")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('el-checkbox', {
    attrs: {
      "disabled": _vm.formData.isTabletEnable
    },
    model: {
      value: (_vm.formData.isTablet),
      callback: function($$v) {
        _vm.$set(_vm.formData, "isTablet", $$v)
      },
      expression: "formData.isTablet"
    }
  }, [_vm._v("Tablet enabled?")])], 1), _vm._v(" "), (_vm.formData.messageBCountry) ? _c('div', {
    staticClass: "col-md-6"
  }, [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("\n                                    " + _vm._s(this.formData.messageBCountry) + "\n                                ")])]) : _vm._e()]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }, [_c('el-button', {
    attrs: {
      "type": "success"
    },
    on: {
      "click": function($event) {
        return _vm.onSubmit()
      }
    }
  }, [_c('i', {
    staticClass: "el-icon-left",
    class: {
      'el-icon-edit': _vm.bucketId !== undefined,
        'el-icon-plus': _vm.bucketId === undefined,
    }
  }), _vm._v("\n                                " + _vm._s(_vm.bucketId === undefined ?
    "Create Bucket" :
    "Edit Bucket") + "\n                            ")]), _vm._v(" "), _c('router-link', {
    staticClass: "el-button el-button--warning",
    attrs: {
      "to": "/admin/domains/"
    }
  }, [_vm._v("\n                                Cancel\n                            ")]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.dialogue_title,
      "visible": _vm.dialogVisible,
      "width": "30%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.confirmation_message)
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.handleDelete()
      }
    }
  }, [_vm._v("Confirm")])], 1)]), _vm._v(" "), _c('el-button', {
    staticClass: "pull-right",
    attrs: {
      "type": "danger",
      "icon": "el-icon-delete",
      "circle": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = true
      }
    }
  })], 1)], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Update Bucket")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d5fd6d00!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/admin/BucketDetails.vue
// module id = 723
// module chunks = 2